import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { addEmployeeType } from '../../../../Store/Admin/EmployeeType/addEmployeeType';
import Header from '../../include/Header';
import Sidebar from '../../include/Sidebar';

const ManageEmployeeType = () => {


  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const data = location.state;
  // console.log(data, '@@')

  useEffect(() => {
    if (localStorage.getItem('PAY_ADMIN_TOKEN') === null) {
      navigate("/admin/login");
    }
  }, [navigate]);

  useEffect(() => {
    if (location.state) {
      setType(location.state?.name);
      setSelectValue(location.state?.status);
    }
  }, [location.state]);



  const [type, setType] = useState('');
  const [disable, setDisable] = useState(false);
  const [error, setError] = useState('');
  const [selectValue, setSelectValue] = useState('');


  const handleRadioChange = (event) => {
    setSelectValue(event.target.checked);
  };

  const handleSubmit = () => {
    if (validation()) {
      setDisable(true)
      const formData = new URLSearchParams();

      formData.append('name', type);
      if (data?._id) {
        formData.append('id', data?._id);
        formData.append('status', selectValue);
      }

      dispatch(addEmployeeType(formData))
        .then((res) => {
          // console.log(res, 'REs');

          if (res.payload.success === true) {
            navigate('/admin/employee-type-management');
            setType('');
          }
          setDisable(false)
        }).catch((error) => {
          console.log(error, 'Error')
          setDisable(false)
        })
    }
  }

  const validation = () => {
    var isValid = true;
    let err = {};
    if (!type || !type?.trim()) {
      isValid = false;
      err['type_err'] = "Please enter type"
    }
    setError(err);
    return isValid;
  }

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  return (
    <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title admin-title">{data?._id ? 'Edit' : 'Add'} Employee Type</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/admin/dashboard">Dashboard</Link></li>
                  <li className="breadcrumb-item"><Link to="/admin/employee-type-management">Employee Type Management</Link></li>
                  <li className="breadcrumb-item active">{data?._id ? 'Edit' : 'Add'} Employee Type</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="card p-3 basicform">

            <div className="row card_id d-flex justify-content-start align-center">
              <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                <div className="cardNum">
                  <div className="mb-3">
                    <label htmlFor="Name" className="form-label">Name</label>
                    <input type="text" className="form-control" id="Name"
                      onChange={(e) => setType(e.target.value)} value={type}
                    />
                    <div className='error'>{error.type_err}</div>
                  </div>
                </div>
              </div>

              {data?._id ? (
                <div className='col-md-4 col-lg-4 col-xxl-4 col-sm-12'>
                  <div className="cardNum">
                    <div className="mb-3">
                      <label htmlFor="fileUpload" className="form-label">Status</label>
                      <div className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" role="switch" onChange={handleRadioChange} checked={selectValue} />
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            <div className="row card_id mt-4 sm-mt-3">
              <div className=" col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                <div className="cardNum">
                  <div className="mb-3 d-flex gap-2">
                    <button className="btn btn-success w-50" type='button' onClick={handleSubmit} disabled={disable}>{disable ? "Processing..." : (data?._id ? 'Update' : 'Submit')}</button>
                    <button className="btn btn-outline-secondary w-50" type='button' onClick={() => setType('')}>Reset</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  )
}

export default ManageEmployeeType